import { defineComponent as _defineComponent } from 'vue'
import { VDivider } from 'vuetify/lib';
	import { mdiWheelchairAccessibility, mdiWheelchair, mdiMapMarker } from '@mdi/js';
	import { computed } from 'vue';

	import IconText from './card-content/icon-text.vue';
	import ContactCard from './card-content/contact-card.vue';
	import RadiologueCard from './card-content/radiologue-card.vue';
	import { Structure } from '@/types/structure';
	import { DISABLED_PEOPLE_ADAPTED_FEATURE_ID, IS_ADAPTED_MAMMOGRAPH_FEATURE_ID } from '@/constants/features';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'structure-card',
  props: {
    structure: null,
    isSelected: { type: Boolean }
  },
  emits: ["select-structure"],
  setup(__props: any, { emit: emits }: { emit: ({
		(e: 'select-structure', structureId: number): void;
	}), expose: any, slots: any, attrs: any }) {

const props = __props as {
		structure: Structure;
		isSelected: boolean;
	};

	

	

	function getFormattedStructureAddress(): string {
		return  `${props.structure.address.label} ${props.structure.address.postal_code} ${props.structure.address.city}`;
	}

	const isDisabledPeopleAdapted = computed(() =>
		props.structure.feature_list.find(f => f.feature_id === DISABLED_PEOPLE_ADAPTED_FEATURE_ID)?.value === 'true');

	const isAdaptedMammography = computed(() =>
		props.structure.feature_list.find(f => f.feature_id === IS_ADAPTED_MAMMOGRAPH_FEATURE_ID)?.value === 'true');

return { __sfc: true,props, emits, getFormattedStructureAddress, isDisabledPeopleAdapted, isAdaptedMammography, VDivider, mdiWheelchairAccessibility, mdiWheelchair, mdiMapMarker, IconText, ContactCard, RadiologueCard }
}

})